import { UpperCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { LegalStatus } from '@cure-common/enum';

@Component({
  selector: 'app-legal-status-chip',
  standalone: true,
  imports: [UpperCasePipe],
  templateUrl: './legal-status-chip.component.html',
  styleUrl: './legal-status-chip.component.scss',
})
export class LegalStatusChipComponent {
  @Input() legalStatus!: LegalStatus;

  protected LegalStatus = LegalStatus;
}
